import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import { FaMoneyBillWave, FaWater, FaTree, FaLink } from "react-icons/fa";
import "./WaterReport3.css";

const comparisonData = [
  {
    metric: "Rebates ($M)",
    val2024: 7.1,
    val2025: 8.5,
  },
  {
    metric: "Lawn (M sq.ft)",
    val2024: 3.1,
    val2025: 3.8,
  },
  {
    metric: "Water Saved (M Gallons)",
    val2024: 100,
    val2025: 125,
  },
];

const WaterReport3 = () => {
  return (
    <div className="report-wrapper">
      {/* HEADER */}
      <div className="report-header">
        <h1>
          <FaMoneyBillWave /> Utah Rebate Programs
        </h1>
        <p>
          Landscape incentive programs help reduce water usage by encouraging
          turf replacement and efficient irrigation systems.
        </p>

        <a
          href="https://slowtheflow.org/rebates/"
          target="_blank"
          rel="noreferrer"
          className="link-btn"
        >
          <FaLink /> View Official Program
        </a>
      </div>

      {/* KPI */}
      <div className="kpi-row">
        <div className="kpi blue">
          <p>2024 - 2025</p>
          <h2>$7.1M - $8.5M</h2>
          <p>Total Rebates</p>
        </div>

        <div className="kpi green">
          <p>2024 - 2025</p>
          <h2>3.1M - 3.8M</h2>
          <p>Lawn Replaced (sq.ft)</p>
        </div>

        <div className="kpi purple">
          <p>2024 - 2025</p>
          <h2>100M - 125M</h2>
          <p>Water Saved (gallons)</p>
        </div>

        <div className="kpi orange">
          <p>2024 - 2025</p>
          <h2>$1 - $3</h2>
          <p>Rebate per sq.ft</p>
        </div>
      </div>

      {/* CHART */}
      <div className="section-card">
        <h3>2024 vs 2025 Comparison</h3>

        <ResponsiveContainer width="100%" height={360}>
          <BarChart
            data={comparisonData}
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" opacity={0.1} />

            <XAxis
              dataKey="metric"
              label={{
                value: "Metric",
                position: "insideBottom",
                offset: -20,
                style: { fill: "#555" },
              }}
            />

            <YAxis
              label={{
                value: "Values",
                angle: -90,
                position: "insideLeft",
                style: { fill: "#555" },
              }}
            />

            <Tooltip
              formatter={(value, name, props) => {
                const metric = props.payload.metric;

                if (metric.includes("($M)")) return `$${value}M`;
                if (metric.includes("(M sq.ft)")) return `${value}M sq.ft`;
                if (metric.includes("(M Gallons)")) return `${value}M Gallons`;

                return value;
              }}
            />

            <Bar dataKey="val2024" fill="#60a5fa" name="2024" />
            <Bar dataKey="val2025" fill="#4ade80" name="2025" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* MAIN TABLE */}
      <div className="section-card">
        <h3>Landscape Incentive Program</h3>

        <table className="clean-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>2024</th>
              <th>2025</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Total Rebates</td>
              <td>$7.1M</td>
              <td>$8.5M</td>
            </tr>
            <tr>
              <td>Lawn Replaced</td>
              <td>3.1M sq.ft</td>
              <td>3.8M sq.ft</td>
            </tr>
            <tr>
              <td>Water Saved</td>
              <td>100M Gallons</td>
              <td>125M Gallons</td>
            </tr>
            <tr>
              <td>Rebate Rate</td>
              <td>$1-$3 per sq.ft</td>
              <td>$1.5-$3 per sq.ft</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* OTHER PROGRAMS */}
      <div className="section-card">
        <h3>Other Rebate Programs</h3>

        <div className="program-grid">
          <div className="program-card">
            <FaWater />
            <h4>Smart Irrigation</h4>
            <p>Up to $100</p>
            <span>Auto weather-based watering</span>
          </div>

          <div className="program-card">
            <FaWater />
            <h4>Toilet Replacement</h4>
            <p>Up to $150</p>
            <span>5 gallons saved per flush</span>
          </div>

          <div className="program-card">
            <FaTree />
            <h4>Tree Rebates</h4>
            <p>$50-$100 per tree</p>
            <span>Reduce evaporation</span>
          </div>

          <div className="program-card">
            <FaWater />
            <h4>Drip Conversion</h4>
            <p>$0.50-$1 per sq.ft</p>
            <span>Efficient targeted watering</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaterReport3;
